function getTabPanelId(tabsKey, tabInfoId, index) {
  return `${tabsKey}-TabPanel-${tabInfoId}-${index}`;
}
function getTabId(tabsKey, tabInfoId, index) {
  return `${tabsKey}-Tab-${tabInfoId}-${index}`;
}
export {
  getTabId,
  getTabPanelId
};
